module.exports = __webpack_public_path__ + "media/images/ipadimage-f862b7798185145c4d5d780d383555bb.png";